<template>
  <b-modal
    :visible="visible"
    no-close-on-backdrop
    centered
    size="sm"
    modal-class="alert-modal"
    header-class="alert-modal-header"
  >
    <template #modal-header="{}">
      <div class="w-100 d-flex align-items-center justify-content-between">
        <h5 class="modal-title">{{ title }}</h5>
        <b-icon-x
          v-if="cancelText"
          class="d-block text-40 text-gray700 cursor-pointer"
          @click="handelCancel"
        ></b-icon-x>
      </div>
    </template>
    <p class="m-0">
      {{ message }}
    </p>
    <template #modal-footer="{}">
      <b-button v-if="cancelText" variant="gray700" @click="handelCancel">{{
        cancelText
      }}</b-button>
      <b-button
        v-if="confirmText"
        variant="secondary"
        style="border-radius: 0.25rem"
        @click="handelConfirm"
        >{{ confirmText }}</b-button
      >
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      promise: null,
      title: '',
      message: '',
      confirmText: '',
      cancelText: '',
    };
  },
  methods: {
    init() {
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.promise = {resolve, reject};
      });
    },
    handelCancel() {
      this.promise.resolve(false);
      this.destroyVm();
    },
    handelConfirm() {
      this.promise.resolve(true);
      this.destroyVm();
    },
    destroyVm() {
      this.visible = false;
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.alert-modal-header {
  padding: 20px;
  .modal-title {
    width: 100%;
    text-align: center;
    font-weight: 400;
  }
}
.alert-modal {
  .modal-content {
    border-radius: 4px;
  }
}
</style>
